<script setup lang="ts">
definePageMeta({
  layout: false,
})

useSetSEO()
useScrollRestoration()

const { locale } = useI18n()
const etcStore = useEtcStore()
const state = reactive({
  isError: false,
  isLoading: false,
})

watch(
  () => locale.value,
  () => {
    setTimeout(() => {
      onLoadData(true)
    })
  }
)

onMounted(() => {
  if (etcStore.eventList.items.length) return
  onLoadData(true)
})

// 보드 리스트 조회
const onLoadData = async (refresh = false) => {
  try {
    state.isLoading = true
    state.isError = false
    await etcStore.fetchBoardList({ ...etcStore.eventList.payload }, refresh)
  } catch {
    state.isError = true
  } finally {
    state.isLoading = false
  }
}
</script>

<template>
  <NuxtLayout name="board">
    <template #leftSideBar>
      <NovaBoxBoardSideMenu :active="'event'" />
    </template>

    <div class="board-wrapper">
      <div class="list-area">
        <span class="title">{{ $t('board.title.event') }}</span>
        <div class="list-box">
          <NovaBoxEmptyMessage
            v-if="
              etcStore.eventList.refresh &&
              !etcStore.eventList.items.length &&
              !state.isError
            "
            :fill="true"
            :message="$t('statusMessages.boardList.empty')"
          />
          <NovaBoxEmptyMessage
            v-if="!etcStore.eventList.items.length && state.isError"
            :fill="true"
            :message="$t('statusMessages.boardList.error')"
          />
          <NovaLoadingIndicator
            v-if="etcStore.eventList.refresh && state.isLoading"
            :size="80"
            :fill="true"
            :bg-bright="'light'"
          />

          <NovaRecyclerGrid
            v-if="etcStore.eventList.items.length"
            :items="etcStore.eventList.items"
            :is-last="etcStore.eventList.last"
            :is-loading="state.isLoading"
            :is-error="state.isError"
            :is-refresh="etcStore.eventList.refresh"
            :key-name="'nttGroupId'"
            :page-mode="true"
            :responsive="{
              mobile: {
                columns: 1,
                rowGap: 20,
                columnGap: 0,
              },
              tablet: {
                columns: 1,
                rowGap: 20,
                columnGap: 0,
              },
              desktop: {
                columns: 1,
                rowGap: 20,
                columnGap: 0,
              },
            }"
            @load-more="onLoadData"
          >
            <template #item="{ item }">
              <NovaBoxBoardListEventItem :source="item" />
            </template>
          </NovaRecyclerGrid>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<style lang="scss" scoped>
.board-wrapper,
.list-area,
.list-box,
.list {
  height: 100%;
  overflow: hidden;
}

.board-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 40px;
  padding-top: 20px;
  color: $color-text-2;

  .list-area {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    > .title {
      @include text-style($text-heading2-bold);
      line-height: 40px;
    }

    .list-box {
      padding-top: 30px;
    }
  }
}

@include mobile {
  .board-wrapper {
    padding: 15px 20px;
    flex-direction: column;
    gap: 20px;

    .list-area {
      width: 100%;

      .list-box {
        padding-top: 15px;
      }
    }
  }
}
</style>
